var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('highlight-html',{attrs:{"queries":_vm.column.meta.highlight().split(' '),"html":_vm.columnContent}})}
var staticRenderFns = []

export { render, staticRenderFns }